<template>
  <div>
    <!-- top -->
    <van-sticky>
      <van-nav-bar class="topNavbar" title="" left-arrow>
        <template #left>
          <van-icon name="arrow-left" style="display: none" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- top -->
    <div class="wrap">
      <!-- :style="{
        backgroundImage:
          'url(' +
          $returnColor().path +
          ($store.state.selfData.member_id
            ? '/home-page_bg.png'
            : '/home-page_bg.png') +
          ')',
      }" -->
      <van-form :submit-on-enter="false" class="formWrap">
        <div style="margin: 16px" class="submitBtn">
          <van-button
            v-if="url.g"
            :color="$returnColor().color3"
            style="width: 88px; height: 34px"
            type="info"
            native-type="submit"
            @click="goUrl('g')"
            >国际站点</van-button
          >
          <van-button
            :color="$returnColor().color3"
            v-if="url.c"
            style="width: 88px; height: 34px; margin-top: 15px"
            type="info"
            native-type="submit"
            @click="goUrl('c')"
            >国内站点</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import urlJSON from "../../../public/ur.json";
export default {
  data() {
    return {
      urlJSON,
      currentManager: "",
      url: {},
    };
  },
  methods: {
    goUrl(method) {
      this.$store.dispatch("setLoadding", true);
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const m = params.get("m");
      if (
        document.domain == "47.242.225.81" ||
        document.domain == "47.83.129.213"
      ) {
        if (m == "js") {
          location.href = `${this.url[method]}/userLogin?m=js`;
        } else {
          location.href = this.url[method];
        }
      } else {
        location.href = this.url[method];
      }
    },
  },
  created() {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    setTimeout(() => {
      let currentManager = urlParams.get("manager");
      if (!currentManager) {
        this.$router.push("/userLogin");
      }
      this.currentManager = currentManager;
      this.url = this.urlJSON[currentManager];
    }, 500);
  },

  destroyed() {},
};
</script>
<style lang="scss" scoped>
.wrap {
  background-position: top;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  min-height: 100vh;
  font-size: 14px;
  display: flex;
  justify-content: center;
}
.formWrap {
  width: 285px;
  border-radius: 10px;
}
.submitBtn {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
}
</style>
